var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"checkbox-container",class:[
    {
      checked: _vm.isChecked,
      circular: _vm.circular,
    },
    _vm.size,
    _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
  ],on:{"click":function($event){!_vm.disabled ? _vm.toggle() : null}}},[_c('label',{staticClass:"label",class:[
      _vm.isChecked ? 'checked' : 'not-checked',
      _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    ]},[_c('span',[_vm._v(" "+_vm._s(_vm.labelText)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }